<template>
  <div class="d-inline-block">
    <!--RECEIPT OK-->

    <v-btn v-if="order.payment.receiptFile" icon x-small class="align-self-center" :href="order.payment.receiptFile"
           target="_blank">
      <v-icon>attachment</v-icon>
    </v-btn>
    <!--BAR RECEIPT-->
    <v-tooltip bottom
               v-else-if="['BANK_TRANSFER','MP_TRANSFER'].includes(order.payment.method) && order.origin === 'BAR' && order.payment.confirmed">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" icon x-small class="align-self-center yellow black--text">
          <v-icon>attachment</v-icon>
        </v-btn>
      </template>
      Cargado por mostrador
    </v-tooltip>

    <!--RECEIPT PENDING-->
    <v-tooltip bottom
               v-else-if="['BANK_TRANSFER','MP_TRANSFER'].includes(order.payment.method) && !order.payment.receiptFile">
      <template v-slot:activator="{on}">
        <v-btn icon x-small class="align-self-center red white--text" target="_blank" v-on="on">
          <v-icon>attachment</v-icon>
        </v-btn>
      </template>
      <span>Comprobante pendiente</span>
    </v-tooltip>

    <!--FAR AWAY-->
    <v-tooltip bottom v-if="order.delivery.mode === 'DELIVERY' && isFarAway(order)">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" icon x-small class="align-self-center purple white--text">
          <v-icon>airplane_ticket</v-icon>
        </v-btn>
      </template>
      Destino lejano ({{ order.delivery.distance }} km)
    </v-tooltip>

    <!--ON BAR-->
    <v-tooltip bottom v-if="order.delivery.onBar === true">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" icon x-small class="align-self-center teal white--text">
          <v-icon>table_bar</v-icon>
        </v-btn>
      </template>
      En Mostrador
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'OrderMenuIcons',
  props: {
    order: {type: Object}
  },
  computed: {
    getMaxKmForMinCost() {
      return this.$store.getters.getSettingValue('maxKmForMinCost')
    }
  },
  methods:{
    isFarAway(order) {
      return (this.getMaxKmForMinCost < order.delivery.distance)
    }
  }
}
</script>
